<script lang="ts">
  import { Pencil, Trash } from "lucide-svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  const current_user = appStore.current_user

  interface Props {
    progress: ProgressType
    type?: string
    onedit?: () => void
    ondelete?: () => void
  }

  let { progress, type = "goal", onedit, ondelete }: Props = $props()
  let marked = $state(false)

  async function deleteProgress(): Promise<void> {
    marked = true
    setTimeout(async () => {
      if (confirm("Are you sure you want to delete the progress?")) {
        try {
          await xhr.delete(
            `/plans/${progress.plan_id}/${type}_progress/${progress.id}`
          )
          ondelete()
        } catch (e) {
          if (typeof Honeybadger.notify !== "undefined") {
            Honeybadger.notify(e)
          }
          toast("There was an error deleting the progress", "error")
        } finally {
          marked = false
        }
      } else {
        marked = false
      }
    })
  }
</script>

<div
  class="bg-green-100 px-6 py-4 my-3 flex justify-between"
  class:bg-blue-100={marked}
  data-name="{type}-progress"
>
  <div class="flex-1">
    <div class="text-sm font-bold flex">
      <h3 class="text-gray-900 font-bold">
        {progress.whodunnit}
      </h3>
      <span class="flex-shrink-0 ml-4 inline-block text-xs"
        >{progress.when}
      </span>
    </div>
    <p class="text-sm mt-1">
      {progress.progress_text}
    </p>
  </div>
  <div
    class="flex items-center pl-6"
    class:hidden={progress.user_id !== current_user.id}
  >
    <button
      class="p-1 flex items-center justify-center"
      data-name="edit-progress"
      onclick={() => onedit()}
    >
      <Pencil class="w-5 h-5 text-gray-400 mr-2 hover:text-blue-500" />
    </button>

    <button
      class="p-1 flex items-center justify-center"
      data-name="delete-progress"
      onclick={deleteProgress}
    >
      <Trash class="w-5 h-5 text-gray-400 hover:text-red-500" />
    </button>
  </div>
</div>
